const Emitter = require('tiny-emitter'); // Wrapper to make it easier to have a class that has the tiny emitter interface


class EmitterInterface {
  on(event, callback, context) {
    return Emitter.prototype.on.call(this, event, callback, context);
  }

  once(event, callback, context) {
    return Emitter.prototype.once.call(this, event, callback, context);
  }

  emit(event, ...args) {
    return Emitter.prototype.emit.call(this, event, ...args);
  }

  off(event, callback) {
    return Emitter.prototype.off.call(this, event, callback);
  }

}

function pipeEvent(event, source, dest) {
  source.on(event, (...args) => dest.emit(event, ...args));
}

module.exports.EmitterInterface = EmitterInterface;
module.exports.pipeEvent = pipeEvent;